// extracted by mini-css-extract-plugin
export default {"wrapper":"_7a82b694"};